import Check from '@mui/icons-material/Check'
import Close from '@mui/icons-material/Close'

const ElementoAer = (props) => {

    const formato = 'text-center'

   
    return (<>
       <div className="w-full flex bg-zinc-200 flex-row justify-between" onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
  <input 
    type="checkbox" 
    id={props.obj.id}  
    checked={props.obj.s}
    onChange={(e => props.elegir(props.obj.id))}
  />
  <div className="px-5 grid grid-cols-11 w-full gap-2">
  <label className="truncate min-w-0" title={props.obj.apellido}>
    {props.obj.apellido}
  </label>
  
  <label className="truncate min-w-0" title={props.obj.nombre}>
    {props.obj.nombre}
  </label>
  
  <label className='truncate min-w-0' title={props.obj.email}>
    {props.obj.email || ''}
  </label>
  
  <label className="truncate min-w-0">
    {props.obj.documento}
  </label>
  
  <label className='text-green-600 flex justify-center'>
    {props.obj.inscripto && <Check className="text-green-600" style={{ fontSize: 24 }} /> }
  </label>
  
  <label className='text-green-600 flex justify-center'>
    {props.obj.acomp && <Check className="text-green-600" style={{ fontSize: 24 }} /> }
  </label>
  
  <label className='flex justify-center text-green-600'>
    {props.obj.expositor && <Check className="text-green-600" style={{ fontSize: 24 }} /> }
  </label>
  
  <label className='flex justify-center text-green-600'>
    {props.obj.acomp ?  
      props.obj.pago_estado==='aprobado' ?
        <Check className="text-green-600" style={{ fontSize: 24 }} />
        :
        <Close className="text-red-600" style={{ fontSize: 24 }} />
    : ''}
  </label>

   <label className='flex justify-center truncate min-w-0'>
    {props.obj.mesa}
  </label>

  <label className='flex justify-center truncate min-w-0'>
    {props.obj.cliente}
  </label>
  
  <label className={formato + " truncate min-w-0"}>
    {props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr),'0')}
  </label>
</div>
</div>
        </>)
}

export default ElementoAer